import styled from "styled-components";
import { Grid, InputLabel, Select, TextField } from "@material-ui/core";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";

export const STFormWrapper = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  width: 400px;
`;

export const STStateGrid = styled(Grid)`
    padding-top: 8px;
    padding-bottom: 12px;
`;

export const STTextField = styled(TextField)`
    margin-top: 10px;
    width: 100%;
`;

export const STAddButtonGrid = styled(Grid)`
    margin-top: 10px;
    align-items: flex-end;
    display: flex;
`;

export const STItemGrid = styled(Grid)`
    display: flex;
    align-items: center;
`;

export const LocationFormSimpleSelect = styled(FormSimpleSelect)`
    width: 100%;
`;
export const STTypeGrid = styled(Grid)`
    margin-top: 20px;
`;

export const STInputLabelType = styled(InputLabel)`
    font-size: 13px;
    padding-bottom: 4px;
`;


export const STSelect = styled(Select)`
    width: 150px;
`;

export const STTypeSelectGrid = styled(Grid)`
    padding-right:5px;
    display: inline;
`;
